define(function(require) {
  return {
    getPortletConfigByInstType: function(instType, portletConfig) {
      switch (instType.toLowerCase()) {
        case "building":
            portletConfigByCDR = portletConfig.building;
          break;
        case "businesslicense":
          portletConfigByCDR = portletConfig.businessLicense;
          break;
        case "codeenforcement":
          portletConfigByCDR = portletConfig.codeEnforcement;
          break;
        case "planning":
          portletConfigByCDR = portletConfig.planning;
          break;
        case "project":
          portletConfigByCDR = portletConfig.project;
          break;
        case "tradelicense":
          portletConfigByCDR = portletConfig.tradeLicense;
          break;
        case "use":
          portletConfigByCDR = portletConfig.use;
          break;
        case "servicerequest":
          portletConfigByCDR = portletConfig.servicerequest;
          break;

        default:

      }
      return portletConfigByCDR;
    }
  }
});
